<template>
	<div>No Results</div>
</template>
<script>
export default {
	name: 'SearchNoRes',
};
</script>
